/* eslint-disable */
import Vue from "vue";
import VueRouter from "vue-router";
import Store from "./Store/store";

import Home from "./components/Home/index.vue";
import Signin from "./components/Signin/index.vue";
import Dashboard from "./components/Dashboard/index.vue";
import MainDashboard from "./components/Dashboard/main.vue";
import AddPostsList from "./components/Dashboard/addPost.vue";
import EditPost from "./components/Dashboard/EditPost.vue";
import PostsList from "./components/Dashboard/listPosts.vue";
import Post from './components/Post/post.vue';
import TagsList from "./components/Tag/tag.vue";
import AddTag from './components/Tag/addTag.vue';
import CategoryList from "./components/Category/category.vue";
import AddCategory from './components/Category/addCategory.vue';
import NotFound from './components/404/index.vue';

Vue.use(VueRouter);

const authGuard = {
  beforeEnter: (to, from, next) => {
    const redirect = () => {
      if (Store.state.admin.token) {
        if (to.path === "/signin") {
          next("/dashboard");
        } else {
          next();
        }
      } else {
        if (to.path === "/signin") {
          next();
        } else {
          next("/");
        }
      }
    };

    if (Store.state.admin.refreshLoading) {
      //async code
      Store.watch(
        (state, getters) => getters["admin/refreshLoading"],
        () => {
          redirect();
        }
      );
    } else {
      redirect();
    }
  }
};

const routes = [
  { path: "/", component: Home },
  { path: "/signin", component: Signin, ...authGuard },
  {
    path: "/dashboard",
    component: Dashboard,
    children: [
      { path: "/", component: MainDashboard },
      { path: "add_posts", component: AddPostsList },
      { path: "posts_list", component: PostsList },
      { path: "add_tags", component: AddTag },
      { path: "tags_list", component: TagsList },
      { path: "categories_list", component: CategoryList },
      { path: "add_categories", component: AddCategory },
      { path: "edit_posts/:id", component: EditPost },
    ],
    ...authGuard
  },
  {path : '/blog/:slug', component: Post},
  {path : '*', component: NotFound}
];

export default new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(from, to, savePosition) {
    return { x: 0, y: 0 };
  }
});
